var map = {
	"./back-arrow.png": 201,
	"./calendar.svg": 126,
	"./chevron-down.png": 202,
	"./closed.png": 127,
	"./dollar.png": 128,
	"./giphy.gif": 85,
	"./loader.gif": 101,
	"./main-icon-small.svg": 110,
	"./main-icon-small1.png": 203,
	"./open.png": 129,
	"./profile-image.png": 204,
	"./profile-image2.png": 205,
	"./profile_pack1.png": 206,
	"./profile_pack2.png": 207,
	"./received.svg": 111,
	"./search.png": 130,
	"./seen.svg": 112,
	"./sent.svg": 87,
	"./shoppingBag.svg": 74,
	"./shoppingCart.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;